import React, { useState } from 'react';
import { FaUsers, FaCalendar, FaPhone, FaEnvelope } from 'react-icons/fa';
import { placeholderImage } from '../utils/placeholderImage';

const CateringPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    eventType: '',
    eventDate: '',
    guestCount: '',
    message: ''
  });

  const cateringPackages = [
    {
      id: 'wedding',
      name: 'Wedding Catering',
      description: 'Make your special day memorable with our authentic Sri Lankan wedding catering service.',
      features: [
        'Custom menu planning',
        'Professional service staff',
        'Setup and cleanup included',
        'Dietary accommodation',
        'Tasting session available'
      ],
      startingPrice: 'Contact for quote'
    },
    {
      id: 'corporate',
      name: 'Corporate Events',
      description: 'Impress your clients and colleagues with our professional corporate catering.',
      features: [
        'Finger food and buffet options',
        'Professional presentation',
        'Dietary requirements met',
        'Flexible timing',
        'Corporate branding available'
      ],
      startingPrice: 'From $25 per person'
    },
    {
      id: 'birthday',
      name: 'Birthday Celebrations',
      description: 'Celebrate your special day with delicious Sri Lankan cuisine.',
      features: [
        'Custom birthday menus',
        'Decorations available',
        'Cake cutting service',
        'Party favors included',
        'Flexible guest counts'
      ],
      startingPrice: 'From $20 per person'
    }
  ];

  const galleryImages = [
    { id: 1, src: '/images/catering-1.jpg', alt: 'Wedding catering setup' },
    { id: 2, src: '/images/catering-2.jpg', alt: 'Corporate event buffet' },
    { id: 3, src: '/images/catering-3.jpg', alt: 'Birthday celebration' },
    { id: 4, src: '/images/catering-4.jpg', alt: 'Private function room' },
    { id: 5, src: '/images/catering-5.jpg', alt: 'Catering service staff' },
    { id: 6, src: '/images/catering-6.jpg', alt: 'Food presentation' }
  ];

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Implement form submission
    alert('Thank you for your catering inquiry! We will contact you soon.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      eventType: '',
      eventDate: '',
      guestCount: '',
      message: ''
    });
  };

  return (
    <div className="catering-page">
      {/* Hero Section */}
      <section className="hero section-full-width">
        <div className="hero-content">
          <h1>Catering Services</h1>
          <p>
            Let us cater your next special event with authentic Sri Lankan cuisine and professional service.
          </p>
        </div>
      </section>

      {/* Catering Packages */}
      <section className="section">
        <div className="section-title">
          <h2>Catering Packages</h2>
          <p>Choose from our range of catering services for your special events</p>
        </div>

        <div className="d-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
          {cateringPackages.map((pkg) => (
            <div key={pkg.id} className="card p-3">
              <h3>{pkg.name}</h3>
              <p>{pkg.description}</p>
              <ul style={{ listStyle: 'none', padding: 0, margin: '1rem 0' }}>
                {pkg.features.map((feature, index) => (
                  <li key={index} style={{ marginBottom: '0.5rem' }}>
                    <span style={{ color: '#ff6b35', marginRight: '0.5rem' }}>✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
              <p style={{ color: '#ff6b35', fontWeight: '600', fontSize: '1.1rem' }}>
                {pkg.startingPrice}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Get Quote Form */}
      <section className="section-full-width" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="section-title">
          <h2>Get a Quote</h2>
          <p>Tell us about your event and we'll provide a customized quote</p>
        </div>

        <div className="d-grid" style={{ gridTemplateColumns: '1fr 1fr', gap: '4rem', maxWidth: '1000px', margin: '0 auto' }}>
          <div className="card p-3">
            <h3>Contact Information</h3>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Your name"
                required
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  marginBottom: '1rem'
                }}
              />
              
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Your email"
                required
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  marginBottom: '1rem'
                }}
              />
              
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="Your phone number"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  marginBottom: '1rem'
                }}
              />
              
              <select
                name="eventType"
                value={formData.eventType}
                onChange={handleInputChange}
                required
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  marginBottom: '1rem'
                }}
              >
                <option value="">Select Event Type</option>
                <option value="wedding">Wedding</option>
                <option value="corporate">Corporate Event</option>
                <option value="birthday">Birthday Party</option>
                <option value="other">Other</option>
              </select>
              
              <input
                type="date"
                name="eventDate"
                value={formData.eventDate}
                onChange={handleInputChange}
                required
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  marginBottom: '1rem'
                }}
              />
              
              <input
                type="number"
                name="guestCount"
                value={formData.guestCount}
                onChange={handleInputChange}
                placeholder="Number of guests"
                required
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  marginBottom: '1rem'
                }}
              />
              
              <textarea
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                placeholder="Tell us about your event requirements..."
                rows="4"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  marginBottom: '1rem',
                  resize: 'vertical'
                }}
              />
              
              <button type="submit" className="btn btn-primary w-full">
                Get Quote
              </button>
            </form>
          </div>

          <div>
            <div className="card p-3 mb-4">
              <h3>Why Choose Our Catering?</h3>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                <li style={{ marginBottom: '1rem' }}>
                  <div className="d-flex align-center">
                    <FaUsers style={{ color: '#ff6b35', marginRight: '1rem' }} />
                    <div>
                      <strong>Professional Service</strong>
                      <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.9rem' }}>
                        Experienced staff for seamless events
                      </p>
                    </div>
                  </div>
                </li>
                <li style={{ marginBottom: '1rem' }}>
                  <div className="d-flex align-center">
                    <FaCalendar style={{ color: '#ff6b35', marginRight: '1rem' }} />
                    <div>
                      <strong>Flexible Scheduling</strong>
                      <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.9rem' }}>
                        Available for events any day of the week
                      </p>
                    </div>
                  </div>
                </li>
                <li style={{ marginBottom: '1rem' }}>
                  <div className="d-flex align-center">
                    <FaPhone style={{ color: '#ff6b35', marginRight: '1rem' }} />
                    <div>
                      <strong>Personal Consultation</strong>
                      <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.9rem' }}>
                        One-on-one planning sessions available
                      </p>
                    </div>
                  </div>
                </li>
                <li style={{ marginBottom: '1rem' }}>
                  <div className="d-flex align-center">
                    <FaEnvelope style={{ color: '#ff6b35', marginRight: '1rem' }} />
                    <div>
                      <strong>Custom Menus</strong>
                      <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.9rem' }}>
                        Tailored to your preferences and dietary needs
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div className="card p-3">
              <h3>Contact Us</h3>
              <p>Ready to discuss your event? Contact us directly:</p>
              <p><strong>Phone:</strong> (08) 6252 8222</p>
              <p><strong>Mobile:</strong> 401 090 451</p>
              <p><strong>Email:</strong> info@nagisceylon.com.au</p>
              <button className="btn btn-primary w-full mt-2">
                Call Now
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Photo Gallery */}
      <section className="section">
        <div className="section-title">
          <h2>Past Catering Events</h2>
          <p>Take a look at some of our recent catering events</p>
        </div>

        <div className="d-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem' }}>
          {galleryImages.map((image) => (
            <div key={image.id} className="card" style={{ overflow: 'hidden' }}>
              <img
                src={image.src}
                alt={image.alt}
                style={{
                  width: '100%',
                  height: '200px',
                  objectFit: 'cover'
                }}
                onError={(e) => {
                  e.target.src = placeholderImage;
                }}
              />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default CateringPage; 